<template>
  <div class="text-center">
    <Loader v-if="!error" />
    <div
      v-if="error"
      class="text-center text-danger pt-5"
    >
      <i
        class="far fa-clock mb-2"
        style="font-size: 30px;"
      />
      <div
        v-if="errorCount >= 5"
        class="mb-2 font-weight-bold"
      >
        Wystąpił błąd autoryzacji.
        Sprawdź czy zegar urządzenia jest prawidłowy i ponów próbę.
      </div>
      <div class="text-danger">
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'OidcCallback',
  data: () => ({
    error: null,
    pending: false,
    errorCount: localStorage.getItem('oidc-callback_error_count') || 0,
  }),
  methods: {
    ...mapActions('oidc', [
      'oidcSignInCallback',
    ]),
  },
  mounted() {
    this.pending = true;
    this.oidcSignInCallback()
      .then((redirectPath) => {
        localStorage.setItem('oidc-callback_error_count', 0);
        this.$router.push(redirectPath);
      })
      .catch((err) => {
        this.pending = false;

        this.errorCount = (this.errorCount || 0) + 1;
        localStorage.setItem('oidc-callback_error_count', this.errorCount);

        // eslint-disable-next-line
        console.error(err);
        this.error = err;

        if (this.errorCount < 5) {
          this.$router.replace('/');
        }
      });
  },
};
</script>
